import styles from './index.module.css'

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import AutoSizer from 'react-virtualized-auto-sizer'
import { FixedSizeList as List } from 'react-window'

import { convertRemToPx } from '@disco/utils/dom'

import type { Track, TrackAlias } from 'types/track'
import type { UserAliasSettings } from 'types/user-settings'

import Alert from 'components/ui/alert'

import MetadataNote from '../metadata-note'
import TrackAliasItem from './track-alias'

type Props = {
  aliases: Record<number, TrackAlias>
  parentAlias: UserAliasSettings
  tracks: Array<Track>
  onAliasChange: (
    trackId: number,
    key: string,
    value: string | null | undefined,
  ) => void
  isTrial?: boolean
  individualEditingEnabled?: boolean
}

class IndividualTab extends Component<
  Props,
  {
    aliases: Record<number, TrackAlias>
  }
> {
  constructor(props: Props) {
    super(props)
    this.state = {
      aliases: props.aliases || {},
    }
  }

  rowRenderer: (arg0: {
    index: number
    style: any
  }) => React.ReactElement<'div'> = ({
    index,
    style,
  }: {
    index: number
    style: Record<string, any>
  }) => {
    const {
      tracks,
      onAliasChange,
      aliases,
      parentAlias,
      individualEditingEnabled,
    } = this.props
    const track = tracks[index]
    if (!track) {
      return <div key={`alias-${index}`} style={style} />
    }
    return (
      <div key={`alias-${index}`} style={style}>
        <TrackAliasItem
          index={index + 1}
          onChange={onAliasChange}
          parentAlias={parentAlias}
          alias={aliases[track.id]}
          track={track}
          disabled={!individualEditingEnabled}
        />
      </div>
    )
  }

  render(): React.ReactElement<'div'> {
    const { isTrial, individualEditingEnabled } = this.props
    return (
      <div>
        {individualEditingEnabled && <MetadataNote />}

        {(isTrial || !individualEditingEnabled) && (
          <React.Fragment>
            <Alert>
              {!individualEditingEnabled ? (
                <>
                  This section allows you to edit the title, artist and album
                  for each track in the playlist individually. To access this
                  feature, upgrade to&nbsp;
                </>
              ) : (
                <>
                  Individual edit metadata alias functionality is available
                  on&nbsp;
                </>
              )}
              <Link to="/settings/billing">Pro.</Link>
            </Alert>
            <br />
          </React.Fragment>
        )}
        <div className={styles.individualTabAliasesHeader}>
          <div />
          <div>Title</div>
          <div>Artist</div>
          <div>Album</div>
        </div>
        <ul className={styles.individualTabAliases}>
          <AutoSizer>
            {({ width, height }) => (
              <List
                width={width}
                height={height}
                itemCount={this.props.tracks.length}
                itemSize={convertRemToPx(2.6)}
                overscanCount={30}
                // SLAM-1970: react-window only re-renders rows when itemData
                // changes, so pass aliases here to reflect edits.
                itemData={this.props.aliases}
              >
                {this.rowRenderer}
              </List>
            )}
          </AutoSizer>
        </ul>
      </div>
    )
  }
}

export default IndividualTab
